import { FC } from 'react';
import { Divider, Stack, Typography } from '@mui/material';
import { UserDetail } from '../../../../types/user';
import { fmtDate } from '../../userShowUtils';
import { KpiInline } from '../../userShowComponents';

/** ④-1. 학습 — 세션 통계 */
const StudyTab: FC<{ user: UserDetail }> = ({ user }) => {
    const study = user.studyStats;
    if (!study) {
        return <Typography color="text.secondary" sx={{ py: 3, textAlign: 'center' }}>학습 데이터가 없습니다.</Typography>;
    }
    return (
        <Stack spacing={2}>
            <Stack direction="row" spacing={4} flexWrap="wrap">
                <KpiInline label="누적 세션" value={study.totalSessions.toLocaleString()} />
                <KpiInline label="최근 7일 세션" value={study.sessionsLast7Days.toLocaleString()} />
                <KpiInline label="최근 30일 세션" value={study.sessionsLast30Days.toLocaleString()} />
                <KpiInline label="총 풀이 항목" value={study.totalItems.toLocaleString()} />
                <KpiInline label="총 학습 시간" value={`${study.totalStudyMinutes.toLocaleString()}분`} />
            </Stack>
            <Divider />
            <Stack direction="row" spacing={4} flexWrap="wrap">
                <KpiInline label="정답 (문항)" value={study.totalCorrectAnswers.toLocaleString()} />
                <KpiInline label="오답 (문항)" value={study.totalWrongAnswers.toLocaleString()} />
                <KpiInline label="정답 (시도)" value={study.totalCorrectAttempts.toLocaleString()} />
                <KpiInline label="오답 (시도)" value={study.totalWrongAttempts.toLocaleString()} />
                <KpiInline label="시도 정확도" value={`${study.accuracyRate.toFixed(2)}%`} />
                <KpiInline label="마지막 학습" value={fmtDate(study.lastStudiedAt)} />
            </Stack>
        </Stack>
    );
};

export default StudyTab;
